import { LitElement, html, svg } from 'lit';

export class IconClock16 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><title>Klokke</title><path stroke="currentColor" stroke-miterlimit="10" stroke-width="1.4" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Z"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.4" d="M8 4.267v4.666l3.111 1.556"></path></svg>`; }
}
if (!customElements.get('f-icon-clock16', IconClock16)) {
  customElements.define('f-icon-clock16', IconClock16);
}